(function(root){
  'use strict';
  const SUN_PRODUCT='10551670997275', SUN_VARIANT='54360236491035', TRACTOR_PRODUCT='10126448886043';
  const units=Object.freeze({'51659187454235':1,'51659187487003':1,'51659187519771':2,'51659187552539':2,'51659187585307':4,'51659187618075':4,'51659187650843':10,'51659187683611':10});
  const id=value=>String(value||'').split('/').pop();
  // Preview arithmetic only. Shopify's native discount owns the actual free credit.
  function evaluate(lines,optional,active,quantity=1){
    let tractorCaps=0,hasTractor=false,eligible=false,sunQuantity=0,sunCents=0,invalid=false;
    for(const line of lines){
      if(!Number.isSafeInteger(line.quantity)||line.quantity<1){invalid=true;continue;}
      if(id(line.productId)===SUN_PRODUCT||id(line.variantId)===SUN_VARIANT){sunQuantity+=line.quantity;sunCents+=Number(line.netCents)||0;continue;}
      if(id(line.productId)===TRACTOR_PRODUCT){hasTractor=true;const count=units[id(line.variantId)];if(!count)invalid=true;else tractorCaps+=count*line.quantity;}
      else if(!line.isGiftCard&&/cap/i.test(line.title||'')&&line.netCents>0)eligible=true;
    }
    const checkboxEligible=!invalid&&!hasTractor&&eligible;
    const requested=checkboxEligible&&optional===true;
    const expected=requested&&active?Math.max(1,Number.isSafeInteger(quantity)?quantity:1):0;
    return {tractorCaps,hasTractor,checkboxEligible,requested,expected,sunQuantity,sunCents,expectedCents:Math.max(0,expected-1)*485,freeQuantity:expected?1:0,blocked:invalid,reason:invalid?'Unrecognized Tractor pack or quantity: review required.':'',mode:hasTractor?'tractor':'optional'};
  }
  const api=Object.freeze({evaluate,SUN_PRODUCT,SUN_VARIANT,TRACTOR_PRODUCT,units});
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.RidekSunRules=api;
})(typeof window==='undefined'?this:window);
